import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { UpdateUtmSourceDialogComponent } from '../update-utm-source-dialog/update-utm-source-dialog.component';
import { ViewTransactionLogComponent } from '../view-transaction-log/view-transaction-log.component';

@Component({
  selector: 'app-list-transaction-log',
  templateUrl: './list-transaction-log.component.html',
  styleUrls: ['./list-transaction-log.component.scss']
})
export class ListTransactionLogComponent implements OnInit {

  downloadReport: boolean = false;

  isLoading: boolean = true;
  isLoadingExtraData: boolean = false;

  dataToEdit: any;

  searchString: any = '';

  p: any = 1;
  count: any = 50;
  limit: any = 500;
  skip: any = 0;

  startDate: any;
  endDate: any;

  listOfTransaction: any = [];
  listOfTransactionToDisplay: any = [];
  userDetails: any;

  status: string = 'SUCCESS';

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.fetchTransactionLog();
  }

  constructor(
    private matDialog: MatDialog,
    public as: AppService,
    public routes: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) { }
  searchTransLog(event: any) {
    // console.log(event.target.value);
    this.searchString = event.target.value;
    let tempList: any = [];
    this.listOfTransactionToDisplay = [...this.listOfTransaction];
    if (this.searchString != '') {
      this.listOfTransactionToDisplay.forEach((transa: any) => {
        if (
          String(transa['user'] == null || transa['user'] == undefined ? 'NA' : transa['user']['email'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(transa['transactionMode'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(transa['transactionStatus'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(transa['transactionSource'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase()) ||
          String(transa['paymentAmount'])
            .toLowerCase()
            .includes(String(this.searchString).toLowerCase())
        ) {
          tempList.push(transa);
        }
      });
      this.listOfTransactionToDisplay = [...tempList];
    } else {
      this.listOfTransactionToDisplay = [...this.listOfTransaction];
    }
  }
  async fetchTransactionLog() {
    this.isLoading = true;
    this.listOfTransaction = [];
    this.listOfTransactionToDisplay = [];
    try {
      let URL = '';
      const param = {
        skip: this.skip,
        limit: this.limit,
        status: this.status,
        startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
        endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
      };
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetails['accessToken']}`,
      });
      URL = `${webApi.domain + webApi.endPoint.fetchTransactionLog}`;

      await this.as.fetchDetail(param, URL, httpHeaders).then((data: any) => {
        if (data['type']) {
          this.listOfTransaction = data['result'];
          this.listOfTransactionToDisplay = this.listOfTransaction;
          this.isLoading = false;
        } else {
          this.listOfTransaction = [];
          this.isLoading = false;
        }
      });
    } catch (error) {
      this.listOfTransaction = [];
      this.isLoading = false;
    }
  }
  async fetchExtraTransactionLog(load: boolean,) {
    this.isLoadingExtraData = load;
    const param = {
      skip: this.skip,
      limit: this.limit,
      status: this.status,
      startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
      endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
    };
    const URL = `${webApi.domain + webApi.endPoint.fetchTransactionLog}`;
    await this.as
      .postMethod(param, URL,)
      .then((data: any) => {
        if (data['type']) {
          data['result'].forEach((user: any) => {
            this.listOfTransaction.push(user);
          });
          this.isLoadingExtraData = false;
        } else {
          this.isLoadingExtraData = false;
        }
      });
  }

  clearDateRange() {
    if (this.endDate != null && this.startDate != null) {
      this.endDate = null;
      this.startDate = null;
      this.fetchTransactionLog();
      this.p = 1;
    }
  }

  setDateNull() {
    this.startDate = null;
    this.endDate = null;
    this.fetchTransactionLog();
  }

  async dateChanged(type: string, event: any) {
    if (type == 'start' && event.value != null) {
      this.startDate = new Date(event.value);
    } else if (type == 'end' && event.value != null) {
      this.endDate = new Date(event.value);
    }
    if (this.startDate != null && this.endDate != null) {
      this.fetchTransactionLog();
    }
  }
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // console.log('index => ', tabChangeEvent.index);
    this.searchString = '';
    if (tabChangeEvent.index == 0) {
      this.status = 'SUCCESS';
    } else {
      this.status = 'FAILED';
    }
    this.fetchTransactionLog();
  }
  pageChanged(event: any) {
    this.p = event;
    console.log(event);

    if (this.p * this.count >= this.listOfTransaction.length - this.count * 3) {
      this.skip = this.skip + this.limit;
      if (!this.isLoadingExtraData) this.fetchExtraTransactionLog(false);
    } else if (this.p * this.count >= this.listOfTransaction.length) {
      this.skip = this.skip + this.limit;
      this.fetchExtraTransactionLog(true);
    }


  }
  viewEditLog(transaction: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { transaction: transaction };
    dialogConfig.width = '45vw';
    dialogConfig.maxWidth = '60vw';
    dialogConfig.maxHeight = '85vh';
    let dialogRef = this.matDialog.open(ViewTransactionLogComponent, dialogConfig);
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      // console.log(res);
      if (res == null) {
        return;
      } else { }
    });
  }

  editUTMSourceLog(transaction: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { transaction: transaction };
    dialogConfig.width = '45vw';
    dialogConfig.maxWidth = '60vw';
    dialogConfig.maxHeight = '85vh';
    let dialogRef = this.matDialog.open(UpdateUtmSourceDialogComponent, dialogConfig);
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      // console.log(res);
      if (res == null) {
        return;
      } else {
        this.listOfTransaction.forEach((element: any) => {
          if (element['_id'] == transaction['_id']) {
            element['utm_source'] = res['utm_source'];
          }
        });
        this.listOfTransactionToDisplay.forEach((element: any) => {
          if (element['_id'] == transaction['_id']) {
            element['utm_source'] = res['utm_source'];
          }
        });
      }
    });
  }
  async generateLogReport() {

    this.downloadReport = true;
    try {
      let URL = '';
      const param = {
        status: this.status,
        startDate: this.startDate == null || this.startDate == undefined ? undefined : new Date(this.startDate.setHours(0, 0, 0, 0)),
        endDate: this.endDate == null || this.endDate == undefined ? undefined : new Date(this.endDate.setHours(23, 59, 59, 59)),
      };
      const httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${this.userDetails['accessToken']}`,
      });
      URL = `${webApi.domain + webApi.endPoint.generateTransactionLogReport}`;

      await this.as.fetchDetail(param, URL, httpHeaders).then((data: any) => {
        if (data['type']) {
          window.open(data['result']);
          this.downloadReport = false;
        } else {
          this.downloadReport = false;
        }
      });
    } catch (error) {
      this.downloadReport = false;
    }
  }
  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }



}
